import { merge, of, fromEvent, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class InternetConnectionService {
	networkStatus$: Observable<boolean>;
	constructor() {
		this.checkNetworkStatus();
	}
	checkNetworkStatus() {
		this.networkStatus$ = merge(of(null), fromEvent(window, 'online'), fromEvent(window, 'offline')).pipe(
			map(() => navigator.onLine)
		);
	}
}
